module.exports = __webpack_public_path__ + "img/monkey-king.d7dc6fe9.jpg";